// @ts-check
import PlayerMarketModel from 'bto-models/match/details/player/player-market.model';
import PlayerOutcomeModel from 'bto-models/match/details/player/player-outcome.model';
import PlayerTabGroupModel from 'bto-models/match/details/player/player-tab-group.model';
import { ITEM_TYPES } from 'bto-models/betslip';
import { isOddActive, getItemHashKey, changeItemOdd } from '@bto-services/betslip-core';

/**
 * Map of all prevoius odds till now, needed for updating the upDownClasses
 */
const prevOddMap = {
  /**
   * @type {{[matchId_marketId_outcomeId:string]: number}}
   */
  val: {},
};

/**
 * Map live player to player tab model
 * @param {import('bto-models/match/details/player/player.api').LivePlayerMarkets} data - raw data
 * @param {{matchId:number,suspended: boolean, isBetStop: boolean}} [match] - the main match object
 * @returns {import('bto-models/match/details/player/player-tab.model').default}
 */
export function mapLivePlayerMarkets(data, match) {
  if (!match || !match.matchId) {
    return {
      name: data.mtn,
      groups: [],
    };
  }
  /**
   * @type {{[matchId_marketId_outcomeId:string]: number}} 
   */
  const newOddMap = {};
  const groups = data.lot.map(lm => {
    const market = new PlayerMarketModel({
      id: lm.id,
      n: lm.n,
      ca: lm.ca,
      c: 0,
    });
    market.isLive = true;
    const playerTabGroup = new PlayerTabGroupModel(lm.n);
    if (lm.ca) {
      playerTabGroup.hasCashout = true;
    }
    playerTabGroup.order = lm.ord;
    playerTabGroup.complexMarket = market;
    /**
     * @type {{[playerKey:string]: import('bto-models/match/details/player/player-tab-group.model').PlayerListModel}}
     */
    const playerListMap = {};

    const ocMap = {};

    lm.o.forEach(o => {
      const ocn = o.ocn;
      const playerName = o.pn;
      if (playerName) {
        const playerOutcome = new PlayerOutcomeModel({
          id: o.id,
          n: '',
          su: o.su,
          o: o.o,
          sbv: o.sbv,
          ocn,
          ord: 1,
          col: o.c,
          ud: o.ud || 0,
          i: o.i,
          a: o.a,
          sp: o.sp,
        }, {});
        playerOutcome.name = `${o.n} ${o.sbv ? `(${o.sbv})` : ''}`;
        playerOutcome.itemType = ITEM_TYPES.LIVE_PLAYER_SWISH;

        if (!ocMap[ocn]) {
          ocMap[ocn] = {
            cn: o.cn,
            co: o.c,
            ocn,
          }
        }

        if (!playerListMap[playerName]) {
          playerListMap[playerName] = {
            name: playerName,
            teamEnum: o.t,
            markets: {},
            outcomes: {},
            sbv: '',
          };
          playerTabGroup.playersList.push(playerListMap[playerName]);
        }
        if (playerOutcome.sbv && playerListMap[playerName].sbv && playerOutcome.sbv !== playerListMap[playerName].sbv) {
          return;
        }
        // If outcome has sbv add this propery to the market as well
        // So we can draw extra colmun for SBV values
        if (playerOutcome.sbv) {
          market.hasSbv = true;
          playerListMap[playerName].sbv = playerOutcome.sbv;
        }
        const itemKeyModel = { matchId: match.matchId, marketId: market.marketId, outcomeId: playerOutcome.id };
        const itemKey = getItemHashKey(itemKeyModel);
        const newOdd = +playerOutcome.originalOdd;

        if (prevOddMap.val[itemKey] && prevOddMap.val[itemKey] !== newOdd) {
          playerOutcome.upDownClass = newOdd > prevOddMap.val[itemKey] ? 1 : -1;
        }
        if (isOddActive(itemKeyModel)) {
          const isBetStop = match.isBetStop || match.suspended || playerOutcome.suspended || playerOutcome.active === false;
          changeItemOdd(itemKeyModel, playerOutcome.originalOdd, isBetStop);
        }
        newOddMap[itemKey] = newOdd;
        playerListMap[playerName].outcomes[playerOutcome.outcomeIdentifier] = playerOutcome;
      }
    });

    playerTabGroup.groupedOutcomes = Object.values(ocMap).map((oc) => {
      return {
        name: oc.cn,
        id: oc.ocn,
        column: oc.co,
      };
    });
    playerTabGroup.groupedOutcomes.sort((a, b) => a.column - b.column);
    // Default to first column
    const outcomeKey = playerTabGroup.groupedOutcomes[0];
    if (outcomeKey) {
      const outcomeId = outcomeKey.id;
      playerTabGroup.playersList.sort((a, b) => {
        const as = (a.outcomes && a.outcomes[outcomeId] && +a.outcomes[outcomeId].outcome) || Infinity;
        const bs = (b.outcomes && b.outcomes[outcomeId] && +b.outcomes[outcomeId].outcome) || Infinity;
        return as - bs;
      });
    }
    return playerTabGroup;
  });

  groups.sort((a, b) => a.order - b.order);

  prevOddMap.val = newOddMap;

  return {
    name: data.mtn,
    groups,
  }
}